(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-banner-dior"] && !Shopify.designMode) return;
  try {
    
  (function() {
    // SPEED FIX (2026-10-01): videos have no src in the HTML; only the active, on-screen slide plays.
    // SPEED FIX 2 (2026-10-24, "the videos take too long to load"):
    //   • start shortly after the page is parsed, not at window "load" — one slow app script or
    //     image held every video back, sometimes for many seconds;
    //   • any browser that plays HLS natively (Safari, iPhone, most Android) streams the adaptive
    //     version, so it starts on a small rendition and steps up; others get the 720p MP4, or
    //     the 480p MP4 on a slow connection;
    //   • a slide is not rotated away while its video is still loading (up to 3× the interval),
    //     which is how a video could look as though it never loaded at all;
    //   • once a video is playing, the next slide's video is fetched quietly so switching is instant.
    var mq = window.matchMedia('(max-width: 749px)');
    var conn = navigator.connection || {};
    var saveData = conn.saveData;
    var slow = /(^|-)2g|3g/.test(conn.effectiveType || '') || (conn.downlink && conn.downlink < 3);
    var probe = document.createElement('video');
    var nativeHls = !!probe.canPlayType && probe.canPlayType('application/vnd.apple.mpegurl') !== '';

    function srcFor(v) {
      var side = mq.matches ? 'mobile' : 'desktop';
      var hls = v.getAttribute('data-hls-' + side);
      if (hls && nativeHls) return hls;
      var sd = v.getAttribute('data-sd-' + side);
      if (slow && sd) return sd;
      return v.getAttribute('data-src-' + side) || sd;
    }

    function load(v, eager) {
      var src = srcFor(v);
      if (!src) { v.classList.remove('is-playing'); return null; }
      if (v.getAttribute('src') !== src) {
        v.classList.remove('is-playing');
        v.preload = eager ? 'auto' : 'metadata';
        v.setAttribute('src', src);
      } else if (eager) {
        v.preload = 'auto';
      }
      return src;
    }

    function pauseSlide(slide) {
      var v = slide && slide.querySelector('[data-hero-video]');
      if (v && !v.paused) v.pause();
    }

    function whenReady(fn) {
      var done = false;
      function go() { if (!done) { done = true; fn(); } }
      if (document.readyState === 'complete') { setTimeout(go, 0); return; }
      window.addEventListener('load', go, { once: true });
      function soon() { setTimeout(go, 600); }
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', soon, { once: true });
      else soon();
    }

    document.querySelectorAll('[data-hero]').forEach(function(hero) {
      var slides = hero.querySelectorAll('[data-hero-slide]');
      var dots = hero.querySelectorAll('[data-hero-dot]');
      var prevBtn = hero.querySelector('[data-hero-prev]');
      var nextBtn = hero.querySelector('[data-hero-next]');
      var autoplay = hero.getAttribute('data-autoplay') === 'true';
      var interval = parseInt(hero.getAttribute('data-interval'), 10) || 6000;
      var current = 0;
      var timer = null;
      var ready = false;
      var visible = true;
      var paused = false;   // hovered or touched
      var waitedSince = 0;

      function videoOf(i) { return slides[i] && slides[i].querySelector('[data-hero-video]'); }

      function warmNext() {
        if (slides.length < 2 || saveData || slow) return;
        var v = videoOf((current + 1) % slides.length);
        if (v) load(v, false);
      }

      function playSlide(i) {
        if (saveData) return;
        var v = videoOf(i);
        if (!v || !load(v, true)) return;
        if (!v.__bnbBound) {
          v.__bnbBound = true;
          v.addEventListener('playing', function() {
            v.classList.add('is-playing');
            if (v === videoOf(current)) { warmNext(); }
          });
        }
        var p = v.play();
        if (p && p.catch) p.catch(function() {}); // e.g. iOS Low Power Mode: poster stays visible
      }

      function syncVideos() {
        if (!ready) return;
        slides.forEach(function(s, i) { (i === current && visible) ? playSlide(i) : pauseSlide(s); });
      }

      whenReady(function() { ready = true; waitedSince = Date.now(); syncVideos(); });
      if (mq.addEventListener) mq.addEventListener('change', syncVideos);

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function(entries) {
          entries.forEach(function(e) {
            visible = e.isIntersecting;
            syncVideos();
            if (slides.length > 1) { visible ? start() : stop(); }
          });
        }, { threshold: 0.1 }).observe(hero);
      }

      if (slides.length <= 1) return;

      function goTo(index) {
        if (index < 0) index = slides.length - 1;
        if (index >= slides.length) index = 0;
        slides.forEach(function(s, i) { s.classList.toggle('is-active', i === index); s.setAttribute('aria-hidden', i === index ? 'false' : 'true'); });
        dots.forEach(function(d, i) { d.classList.toggle('is-active', i === index); d.setAttribute('aria-selected', i === index ? 'true' : 'false'); });
        current = index;
        waitedSince = Date.now();
        syncVideos();
      }
      function next() { goTo(current + 1); }
      function prev() { goTo(current - 1); }
      // Rotate only once the active slide's video has had a chance to play.
      function tick() {
        var v = videoOf(current);
        var stillLoading = ready && !saveData && v && v.getAttribute('src') && !v.classList.contains('is-playing');
        if (stillLoading && Date.now() - waitedSince < interval * 3) return;
        next();
      }
      function start() {
        if (!autoplay || paused) return;
        stop(); waitedSince = Date.now(); timer = setInterval(tick, interval);
      }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      dots.forEach(function(dot) { dot.addEventListener('click', function() { goTo(parseInt(dot.getAttribute('data-index'), 10)); start(); }); });
      if (prevBtn) prevBtn.addEventListener('click', function() { prev(); start(); });
      if (nextBtn) nextBtn.addEventListener('click', function() { next(); start(); });
      hero.addEventListener('mouseenter', function() { paused = true; stop(); });
      hero.addEventListener('mouseleave', function() { paused = false; start(); });
      var startX = null;
      hero.addEventListener('touchstart', function(e) { startX = e.touches[0].clientX; stop(); }, { passive: true });
      hero.addEventListener('touchend', function(e) { if (startX === null) return; var diff = e.changedTouches[0].clientX - startX; if (Math.abs(diff) > 40) { diff < 0 ? next() : prev(); } startX = null; start(); }, { passive: true });
      start();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
